import axiosAuth from './axiosAuth'

export const getSlotsForms = (controller: AbortController) =>
    axiosAuth.get<string>('/slots_and_forms', {
        signal: controller.signal,
    })

export const putSlotsForms = (data: string) =>
    axiosAuth.put('/slots_and_forms', data)
